import axios, { AxiosRequestConfig, CancelToken } from 'axios';

type RequestHeaderType = {
  'x-api-key'?: string;
  token?: string;
  language?: string;
  isRemake?: boolean;
  uuid?: string;
  mature?: number;
  isAlreadyMature?: boolean;
  is17?: boolean;
  offset?: number;
};

interface RequestDefaults<T = any> {
  header: RequestHeaderType;
  method?: 'get' | 'post';
  url: string;
  data?: T;
  params?: any;
  responseType?: 'json';
  cancelToken?: CancelToken | null;
}

/**
 * 관리자용 axios header type
 * @param param0
 * @returns
 */
interface RequestManagerHeaderType {
  'x-api-key'?: string;
  accesstoken?: string;
  language?: string;
}

/**
 * 관리자용 axios requext type
 * @param param0
 * @returns
 */
interface RequestManagerDefaults<T = any> {
  header: RequestManagerHeaderType;
  method?: 'get' | 'post';
  url: string;
  data?: T;
  params?: any;
  responseType?: 'json';
  cancelToken?: CancelToken | null;
  progressCallback?: ((progressEvent: any) => void) | null;
}

export namespace Axios {
  /**
   * Axios 요청 인스턴스
   * @param data 타입 가급적 명세
   * @returns
   */

  export const Client = <T extends unknown>({
    header,
    method = 'post',
    url,
    responseType = 'json',
    params,
    data,
    cancelToken = null,
  }: RequestDefaults<T>) => {
    const headers = header;

    if (!headers.token) delete headers.token;
    if (!headers.language) delete headers.language;
    if (!headers.isRemake) delete headers.isRemake;
    if (!headers.uuid) delete headers.uuid;
    if (!headers.mature) delete headers.mature;
    if (!headers.is17) delete headers.is17;
    if (!headers.isAlreadyMature) delete headers.isAlreadyMature;

    const requestConfig: AxiosRequestConfig | any = {
      method,
      url,
      responseType,
      headers,
      data,
      params,
      cancelToken,
    };

    if (cancelToken === null) {
      delete requestConfig.cancelToken;
    }

    return axios.request(requestConfig);
  };

  /**
   * 관리자용 axios object
   * @param param0
   * @returns
   */
  export const Manager = <T extends unknown>({
    header,
    method = 'post',
    url,
    responseType = 'json',
    params,
    data,
    cancelToken = null,
    progressCallback = null,
  }: RequestManagerDefaults<T>) => {
    const headers = header;

    const requestConfig: AxiosRequestConfig | any = {
      method,
      url,
      responseType,
      headers,
      data,
      params,
    };

    if (cancelToken !== null) {
      requestConfig.cancelToken = cancelToken;
    }

    if (progressCallback !== null) {
      requestConfig.onUploadProgress = progressCallback;
    }

    return axios.request(requestConfig);
  };
}
